import { LoadingSpinner } from "@/components/loading-spinner";

export function DetailPageLoading() {
  return (
    <div className="container mx-auto px-4 py-8 flex justify-center">
      <LoadingSpinner />
    </div>
  );
}
